module.exports = __webpack_public_path__ + "img/fyg-logo.97e17e5c.png";